import {
    RaikoBaseDialogContentContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer, RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {GameTeamService} from "../../serverService/gameService/GameTeamService";
import {css} from "@emotion/css";

export default function AddNewTeam({gamePeriodId, handleCloseDialog, handleAddNewTeamToTable}) {


    const [teamTitle, setTeamTitle] = useState("");
    const [actionButtonLoading, setActionButtonLoading] = useState(false)

    const service = new GameTeamService()


    function handleAddNewTeam() {
        setActionButtonLoading(true)
        service.addNewTeam(gamePeriodId, teamTitle)
            .then(
                response => {
                    handleCloseDialog()
                    handleAddNewTeamToTable(response)
                    showSuccessMessage("تیم جدید با موفقیت افزوده شد.")
                }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن تیم جدید"}
                hasActionButton
                actionButtonOnclickWithValidation={handleAddNewTeam}
                actionButtonTitle={"افزودن"}
                actionButtonLoadingState={actionButtonLoading}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseDialog}
            >
                <RaikoGridOneColumn className={css`width: 100%`}>
                    <RaikoSimpleInputOutlined
                        labelText={"عنوان تیم"}
                        value={teamTitle}
                        setValue={setTeamTitle}
                        required
                    />

                </RaikoGridOneColumn>

            </RaikoSectionContainer>

        </RaikoBaseDialogContentContainer>
    )
}